module.exports = __webpack_public_path__ + "static/img/6.64508e7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/3/sp/6.png
// module id = Knpv
// module chunks = 0